// extracted by mini-css-extract-plugin
export default {"link":"LK-z","disabled":"MK-z"};